import { Box, Stack } from "@mui/material";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import { SSText } from "./SSText";
import React from "react";

function groupFaqItems(faqs: TTeamConfig["LANGUAGES"]["FAQS"]) {
  const groups: (string | React.ReactNode)[] = [];
  faqs.forEach((itm) => {
    if (itm.group && !groups.includes(itm.group)) {
      groups.push(itm.group);
    }
  });
  if (groups.length) {
    return groups.map((group, idx) => {
      return {
        group,
        faqs: faqs.filter((itm) => itm.group === group),
      };
    });
  }
  return [{ group: "", faqs }];
}

export function Faqs(props: {
  faqs: TTeamConfig["LANGUAGES"]["FAQS"];
  hideTitle?: boolean;
}) {
  const faqsGrouped = groupFaqItems(props.faqs);

  return (
    <Stack spacing={6}>
      {!props?.hideTitle ? (
        <Box textAlign={"center"}>
          <SSText
            variant="h5"
            fontWeight={700}
            sx={{ textDecoration: "underline", textUnderlineOffset: "0.2em" }}
          >
            Frequently Asked Questions
          </SSText>
        </Box>
      ) : null}

      <Stack spacing={3}>
        {faqsGrouped.map((group, idx) => {
          return (
            <Stack key={idx} spacing={2}>
              {group?.group ? (
                <Box>
                  <SSText variant="h5" fontWeight={700}>
                    {group.group}
                  </SSText>
                </Box>
              ) : null}

              {group.faqs.map((itm, idx) => {
                return (
                  <Stack spacing={1} key={idx}>
                    {itm.question ? (
                      <SSText variant="h6" fontWeight={700} fontSize={"1rem"}>
                        {idx + 1}. {itm.question}
                      </SSText>
                    ) : null}
                    <SSText variant="body">{itm.answer}</SSText>
                  </Stack>
                );
              })}
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}
